import SiteHeader from '@components/shared/SiteHeader';
import { getBytesStrapiUrl } from '@lib/bytesStrapiServices';
import { LANG_MAP } from '@lib/constants';
import { getImgUrl } from '@utils/functions/getImgUrl';
import axios from 'axios';
import Link from 'next/link';
import React from 'react';
import { BsArrowRight } from 'react-icons/bs';

function CompilerList({ languageList }) {
  return (
    <>
      <SiteHeader
        title="Online Compiler  -  AlmaBetter"
        desc="AlmaBetter Online Compiler lets you compile, run and debug programs online. Write a code in an online compiler section and click on run to execute the code."
      />
      <div className="mx-8 my-8 flex flex-col items-start gap-y-6 md:mx-20">
        <div>
          <h1 className="font-satoshi-bold text-3xl font-bold">Online Compilers</h1>
          <p className="font-satoshi-medium text-lg">Select a compiler to run your code online</p>
        </div>
        <div className="mb-20 mt-10 grid w-full gap-12 md:grid-cols-3 md:grid-rows-2">
          {languageList?.map(({ id, attributes }) => (
            <RedirectCard key={id} name={attributes?.language} icon={getImgUrl(attributes?.icon)} />
          ))}
        </div>
      </div>
    </>
  );
}

export default CompilerList;

function RedirectCard({ name, icon }) {
  const redirectLang = LANG_MAP[name];
  const logo = typeof icon === 'string' ? icon : '/assets/text-block.svg';

  return (
    <Link
      href={`/online-compiler/${redirectLang}`}
      as={`/online-compiler/${redirectLang}`}
      passHref
    >
      <a
        className="flex cursor-pointer flex-col items-start gap-y-6 rounded-xl bg-white px-8 py-5 transition duration-500 hover:scale-110"
        style={{
          boxShadow: '2px 4px 10px 0 rgba(0, 0, 0, 0.2)',
        }}
      >
        <div>
          <img src={logo} className="h-10 object-contain" />
        </div>
        <div className="flex w-full items-center justify-between">
          <p className="font-satoshi-medium font-medium">{name} Compiler</p>
          <BsArrowRight size={22} />
        </div>
      </a>
    </Link>
  );
}

export async function getStaticProps() {
  try {
    const bytesAPIBaseURL = getBytesStrapiUrl();

    const {
      data: { data },
    } = await axios.get(`${bytesAPIBaseURL}/api/compilers?populate=icon`);

    return { props: { languageList: data || [] }, revalidate: 3600 };
  } catch (error) {
    return { props: { error } };
  }
}
